import {
    cilUser,
    cilFile,
    cilLockLocked,
    cilLockUnlocked,    
    cilAccountLogout,
    cilCloudDownload,
    cilHome
} from '@coreui/icons';
export const iconsSet = Object.assign(
  {
    cilUser,
    cilFile,
    cilLockLocked,
    cilLockUnlocked,    
    cilAccountLogout,
    cilCloudDownload,
    cilHome
  }
);